// Main Components
import * as React from "react"
import parse from "html-react-parser"
import "./resources_faq.scss"


const FAQSection = ({sectionContent}) => {
  return (
    <div className="faq-section">
        <h2>Frequently asked questions...</h2>
        <div>
          <div className='faq'>
            {parse(sectionContent)}
          </div>
        </div>
    </div>
  )
}

export default FAQSection
